import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import CookiePolicy from "./Component/CookiePolicy";
import Faq from "./Component/Faq";
import {
  AccessibilityStatement,
  ComplaintsPolicy,
  DutiesPolicy,
  IntellectualPropertyPolicy,
  MarketingPolicy,
  OrderPolicy,
  PaymentPolicy,
  PolicyCenter,
  PricingPolicy,
  PrivacyChoices,
  ProductCarePolicy,
  ProductSafetyPolicy,
  SecurityPolicy,
  UserContentPolicy,
  WarrantyPolicy,
} from "./Component/AdditionalPolicies";

function App() {
  return (
    <CartProvider>
      <Router>
        <Header />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/shipping" element={<Delivery />} />
          <Route path="/" element={<Main />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/policies" element={<PolicyCenter />} />
          <Route path="/payment-policy" element={<PaymentPolicy />} />
          <Route path="/order-policy" element={<OrderPolicy />} />
          <Route path="/warranty" element={<WarrantyPolicy />} />
          <Route path="/product-care" element={<ProductCarePolicy />} />
          <Route path="/duties-taxes" element={<DutiesPolicy />} />
          <Route path="/pricing-promotions" element={<PricingPolicy />} />
          <Route path="/accessibility" element={<AccessibilityStatement />} />
          <Route path="/intellectual-property" element={<IntellectualPropertyPolicy />} />
          <Route path="/user-content" element={<UserContentPolicy />} />
          <Route path="/marketing-communications" element={<MarketingPolicy />} />
          <Route path="/security" element={<SecurityPolicy />} />
          <Route path="/complaints" element={<ComplaintsPolicy />} />
          <Route path="/product-safety" element={<ProductSafetyPolicy />} />
          <Route path="/privacy-choices" element={<PrivacyChoices />} />
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/payment" element={<PaySuccess />} />
          <Route path="/paysuccess" element={<PaySuccess />} />
        </Routes>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
